import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-weather-icons-page-configurator',
	templateUrl:'./WeatherIconsPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./WeatherIconsPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WeatherIconsPageConfiguratorPluginCompPage
{
	mdContent_1164 = `\`\`\`java
import com.jwebmp.plugins.weathericons.WeatherIconsPageConfigurator;
\`\`\``;
	mdContent_1165 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.weathericons;
}
\`\`\``;
}
